import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Section from "./components/Section";
import Shop from "./components/Shop";
import ArtworkDetails from "./components/ArtworkDetails";
import Cart from "./components/Cart";
import Checkout from "./components/Checkout";
import Footer from "./components/Footer";
import Admin from "./components/Admin";

import { CartProvider } from "./CartContext";
import "./App.css";

const Home = () => (
  <>
    <Hero />

    <Section title="All Artworks" 
      slogan="ಸತ್ಯಮೇವ ಜಯತೇ"
      category="other"
      bgClass="section-1"
    />

    <Section title="Karnataka"
      slogan="ಎಲ್ಲಾದರೂ ಇರು, ಎಂತಾದರೂ ಇರು, ಎಂದೆಂದಿಗೂ ನೀ ಕನ್ನಡವಾಗಿರು"
      category="karnataka"
      bgClass="section-2"
    />

    <Section title="History"
      slogan="ಮಾತಲ್ಲ, ಮಹತ್ವದ ವಿಷಯ"
      category="history"
      bgClass="section-3"
    />

    <Section title="Content Creators"
      slogan="ಆನ್ಲೈನ್‌ನಲ್ಲಿ ಕನ್ನಡದ ಅಲೆ"
      category="content_creators"
      bgClass="section-4"
    />
  </>
);

const App = () => (
  <CartProvider>
    <Router>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/shop" element={<Shop />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/checkout" element={<Checkout />} />

        {/* DETAILS PAGE */}
        <Route path="/artwork/:id" element={<ArtworkDetails />} />
      </Routes>

      <Footer />
    </Router>
  </CartProvider>
);

export default App;
